import dayjs from 'dayjs';

const localizeDate = (date: Date, format = 'MMMM D, YYYY'): string => dayjs(date).format(format);

export default localizeDate;
